'use strict';

var _ = require('lodash');
var ProfileChartConstants = function ProfileChartConstants(ChartElementsConstants, dataRetrieverConstantsService) {
  var BASE = {
    LEGEND_ITEM: 'legendItem',
    CURRENT: ChartElementsConstants.PIN_LINE.CURRENT,
    EXPECTED: 'Exp',
    CURRENT_LY: 'Curr LY',
    CURRENT_SEASONAL_AVERAGE: 'Curr Season Avg',
    CAPACITY: 'Cap',
    DA_CAPACITY: 'Capacity',
    DA_CAPACITY_SEASON_AVG: 'Capacity Season Avg',
    SEASON_AVERAGE: 'Season Average',
    CAPACITY_LY: 'Cap LY',
    MIN: 'Min',
    AVG: 'Avg',
    MAX: 'Max',
    BOOKING_CURVE_CURRENT_YEAR: 'bookingCurveCurrentYear',
    BOOKING_CURVE_LAST_YEAR: 'bookingCurveLastYear',
    BOOKING_CURVE_REFERENCE: 'bookingCurveReference',
    BOOKING_CURVE_SEASONAL_AVERAGE: 'bookingCurveSeasonalAverage',
    REVENUE_CURVE_CURRENT_YEAR: 'revenueCurveCurrentYear',
    REVENUE_CURVE_LAST_YEAR: 'revenueCurveLastYear',
    REVENUE_CURVE_SEASONAL_AVERAGE: 'revenueCurveSeasonalAverage',
    LOAD_FACTOR_CURVE_CURRENT_YEAR: 'loadFactorCurveCurrentYear',
    LOAD_FACTOR_CURVE_LAST_YEAR: 'loadFactorCurveLastYear',
    LOAD_FACTOR_CURVE_REFERENCE: 'loadFactorCurveReference',
    LOAD_FACTOR_CURVE_SEASONAL_AVERAGE: 'loadFactorCurveSeasonalAverage',
    BOOKINGS_EXPECTED: 'resHoldTotalExpected',
    REVENUE_EXPECTED: 'revenueExpected',
    REVENUE_EXPECTED_FLIGHT: 'revenueExpected',
    LOAD_FACTOR_EXPECTED_FLIGHT: 'loadFactorExpected',
    CAPACITY_CURVE_CURRENT_YEAR: 'capacityCurveCurrentYear',
    CAPACITY_CURVE_LAST_YEAR: 'capacityCurveLastYear',
    CAPACITY_CURVE_REFERENCE: 'capacityCurveReference',
    LY_CUSTOM_DASH: '4,2',
    CAPACITY_CUSTOM_DASH: '3,4,14,4,3,4',
    BOOKING_CURVE_URD_MIN: 'minURDBookingCurve',
    BOOKING_CURVE_URD_MAX: 'maxURDBookingCurve',
    BOOKING_CURVE_URD_AVG: 'avgURDBookingCurve',
    REVENUE_CURVE_URD_MIN: 'minURDRevenueCurve',
    REVENUE_CURVE_URD_MAX: 'maxURDRevenueCurve',
    REVENUE_CURVE_URD_AVG: 'avgURDRevenueCurve',
    LOAD_FACTOR_CURVE_URD_MIN: 'minURDLoadFactorCurve',
    LOAD_FACTOR_CURVE_URD_MAX: 'maxURDLoadFactorCurve',
    LOAD_FACTOR_CURVE_URD_AVG: 'avgURDLoadFactorCurve',
    REFERENCE_LY: 'lastYear',
    REFERENCE_SEASONAL_AVERAGE: 'seasonalAverage'
  };
  return {
    CURRENT: BASE.CURRENT,
    EXPECTED: BASE.EXPECTED,
    CURRENT_LY: BASE.CURRENT_LY,
    CAPACITY: BASE.CAPACITY,
    DA_CAPACITY: BASE.DA_CAPACITY,
    CAPACITY_LY: BASE.CAPACITY_LY,
    MIN: BASE.MIN,
    AVG: BASE.AVG,
    MAX: BASE.MAX,
    SEASON_AVERAGE: BASE.SEASON_AVERAGE,
    CURRENT_SEASONAL_AVERAGE: BASE.CURRENT_SEASONAL_AVERAGE,
    DA_CAPACITY_SEASON_AVG: BASE.DA_CAPACITY_SEASON_AVG,
    REFERENCE_LY: BASE.REFERENCE_LY,
    REFERENCE_SEASONAL_AVERAGE: BASE.REFERENCE_SEASONAL_AVERAGE,
    LINE: 'line',
    STROKE_WIDTH: '4',
    MAX_AMOUNT_OF_REFERENCE_ENTITIES: 5,
    CAPACITY_CUSTOM_DASH: BASE.CAPACITY_CUSTOM_DASH,
    LY_CUSTOM_DASH: BASE.LY_CUSTOM_DASH,
    BOOKING_CURVE_CURRENT_YEAR: BASE.BOOKING_CURVE_CURRENT_YEAR,
    BOOKING_CURVE_LAST_YEAR: BASE.BOOKING_CURVE_LAST_YEAR,
    CAPACITY_CURVE_CURRENT_YEAR: BASE.CAPACITY_CURVE_CURRENT_YEAR,
    CAPACITY_CURVE_LAST_YEAR: BASE.CAPACITY_CURVE_LAST_YEAR,
    REVENUE_CURVE_CURRENT_YEAR: BASE.REVENUE_CURVE_CURRENT_YEAR,
    REVENUE_CURVE_LAST_YEAR: BASE.REVENUE_CURVE_LAST_YEAR,
    LOAD_FACTOR_CURVE_CURRENT_YEAR: BASE.LOAD_FACTOR_CURVE_CURRENT_YEAR,
    LOAD_FACTOR_CURVE_LAST_YEAR: BASE.LOAD_FACTOR_CURVE_LAST_YEAR,
    BOOKINGS_EXPECTED: BASE.BOOKINGS_EXPECTED,
    REVENUE_EXPECTED: BASE.REVENUE_EXPECTED,
    REVENUE_EXPECTED_FLIGHT: BASE.REVENUE_EXPECTED_FLIGHT,
    BOOKING_CURVE_URD_MIN: BASE.BOOKING_CURVE_URD_MIN,
    BOOKING_CURVE_URD_MAX: BASE.BOOKING_CURVE_URD_MAX,
    BOOKING_CURVE_URD_AVG: BASE.BOOKING_CURVE_URD_AVG,
    REVENUE_CURVE_URD_MIN: BASE.REVENUE_CURVE_URD_MIN,
    REVENUE_CURVE_URD_MAX: BASE.REVENUE_CURVE_URD_MAX,
    REVENUE_CURVE_URD_AVG: BASE.REVENUE_CURVE_URD_AVG,
    LOAD_FACTOR_URD_MIN: BASE.LOAD_FACTOR_CURVE_URD_MIN,
    LOAD_FACTOR_URD_MAX: BASE.LOAD_FACTOR_CURVE_URD_MAX,
    LOAD_FACTOR_URD_AVG: BASE.LOAD_FACTOR_CURVE_URD_AVG,
    LEGEND_ITEM: BASE.LEGEND_ITEM,
    LEGEND_ITEMS: [{
      label: BASE.CURRENT,
      fill: _.kebabCase(BASE.LEGEND_ITEM + BASE.CURRENT),
      metrics: ['booking', 'revenue', 'loadFactor']
    }, {
      label: BASE.EXPECTED,
      fill: _.kebabCase(BASE.LEGEND_ITEM + BASE.EXPECTED),
      dashed: true,
      metrics: ['booking', 'revenue', 'loadFactor']
    }, {
      label: BASE.CAPACITY,
      fill: _.kebabCase(BASE.LEGEND_ITEM + BASE.CAPACITY),
      dashed: true,
      customDash: BASE.CAPACITY_CUSTOM_DASH,
      strokeWidth: BASE.STROKE_WIDTH,
      metrics: ['booking']
    }, {
      label: BASE.CAPACITY_LY,
      fill: _.kebabCase(BASE.LEGEND_ITEM + BASE.CAPACITY_LY),
      dashed: true,
      customDash: BASE.LY_CUSTOM_DASH,
      strokeWidth: BASE.STROKE_WIDTH,
      metrics: ['booking']
    }, {
      label: BASE.CURRENT_LY,
      fill: _.kebabCase(BASE.LEGEND_ITEM + BASE.CURRENT_LY),
      dashed: true,
      customDash: BASE.LY_CUSTOM_DASH,
      referenceType: BASE.REFERENCE_LY,
      metrics: ['booking', 'revenue', 'loadFactor']
    }, {
      label: BASE.CURRENT_SEASONAL_AVERAGE,
      fill: _.kebabCase(BASE.LEGEND_ITEM + BASE.CURRENT_SEASONAL_AVERAGE),
      dashed: true,
      customDash: BASE.LY_CUSTOM_DASH,
      referenceType: BASE.REFERENCE_SEASONAL_AVERAGE,
      metrics: ['booking', 'revenue', 'loadFactor']
    }, {
      label: BASE.MIN,
      fill: _.kebabCase(BASE.LEGEND_ITEM + BASE.MIN),
      metrics: ['booking', 'revenue', 'loadFactor']
    }, {
      label: BASE.AVG,
      fill: _.kebabCase(BASE.LEGEND_ITEM + BASE.AVG),
      metrics: ['booking', 'revenue', 'loadFactor']
    }, {
      label: BASE.MAX,
      fill: _.kebabCase(BASE.LEGEND_ITEM + BASE.MAX),
      metrics: ['booking', 'revenue', 'loadFactor']
    }],
    DA_LEGEND_ITEMS: [{
      label: BASE.CURRENT,
      fill: _.kebabCase(BASE.LEGEND_ITEM + BASE.CURRENT),
      metrics: ['booking', 'loadFactor']
    }, {
      label: BASE.SEASON_AVERAGE,
      fill: _.kebabCase(BASE.LEGEND_ITEM + BASE.SEASON_AVERAGE),
      metrics: ['booking', 'loadFactor']
    }, {
      label: BASE.DA_CAPACITY,
      fill: _.kebabCase(BASE.LEGEND_ITEM + BASE.DA_CAPACITY),
      dashed: true,
      customDash: BASE.CAPACITY_CUSTOM_DASH,
      strokeWidth: BASE.STROKE_WIDTH,
      metrics: ['booking']
    }, {
      label: BASE.DA_CAPACITY_SEASON_AVG,
      fill: _.kebabCase(BASE.LEGEND_ITEM + BASE.DA_CAPACITY_SEASON_AVG),
      dashed: true,
      customDash: BASE.CAPACITY_CUSTOM_DASH,
      strokeWidth: BASE.STROKE_WIDTH,
      metrics: ['booking']
    }],
    AVAILABLE_CURVES: {
      booking: [{
        name: BASE.BOOKING_CURVE_CURRENT_YEAR,
        pinLineLabel: BASE.CURRENT,
        prolongWithExpect: true,
        squareIndicatorsType: BASE.CURRENT
      }, {
        name: BASE.BOOKING_CURVE_LAST_YEAR,
        pinLineLabel: BASE.CURRENT_LY,
        dotted: true,
        customDash: BASE.LY_CUSTOM_DASH,
        squareIndicatorsType: BASE.CURRENT_LY,
        referenceType: BASE.REFERENCE_LY
      }, {
        name: BASE.BOOKING_CURVE_SEASONAL_AVERAGE,
        pinLineLabel: BASE.CURRENT_SEASONAL_AVERAGE,
        dotted: true,
        customDash: BASE.LY_CUSTOM_DASH,
        squareIndicatorsType: BASE.CURRENT_SEASONAL_AVERAGE,
        referenceType: BASE.REFERENCE_SEASONAL_AVERAGE
      }, {
        name: BASE.CAPACITY_CURVE_CURRENT_YEAR,
        pinLineLabel: BASE.CAPACITY,
        dotted: true,
        customDash: BASE.CAPACITY_CUSTOM_DASH
      }, {
        name: BASE.CAPACITY_CURVE_LAST_YEAR,
        pinLineLabel: BASE.CAPACITY_LY,
        dotted: true,
        customDash: BASE.LY_CUSTOM_DASH
      }, {
        name: BASE.BOOKING_CURVE_URD_MIN,
        pinLineLabel: BASE.MIN
      }, {
        name: BASE.BOOKING_CURVE_URD_MAX,
        pinLineLabel: BASE.MAX
      }, {
        name: BASE.BOOKING_CURVE_URD_AVG,
        pinLineLabel: BASE.AVG
      }],
      revenue: [{
        name: BASE.REVENUE_CURVE_CURRENT_YEAR,
        pinLineLabel: BASE.CURRENT,
        prolongWithExpect: true,
        squareIndicatorsType: BASE.CURRENT
      }, {
        name: BASE.REVENUE_CURVE_LAST_YEAR,
        pinLineLabel: BASE.CURRENT_LY,
        dotted: true,
        customDash: BASE.LY_CUSTOM_DASH,
        squareIndicatorsType: BASE.CURRENT_LY,
        referenceType: BASE.REFERENCE_LY
      }, {
        name: BASE.REVENUE_CURVE_SEASONAL_AVERAGE,
        pinLineLabel: BASE.CURRENT_SEASONAL_AVERAGE,
        dotted: true,
        customDash: BASE.LY_CUSTOM_DASH,
        squareIndicatorsType: BASE.CURRENT_SEASONAL_AVERAGE,
        referenceType: BASE.REFERENCE_SEASONAL_AVERAGE
      }, {
        name: BASE.REVENUE_CURVE_URD_MIN,
        pinLineLabel: BASE.MIN
      }, {
        name: BASE.REVENUE_CURVE_URD_MAX,
        pinLineLabel: BASE.MAX
      }, {
        name: BASE.REVENUE_CURVE_URD_AVG,
        pinLineLabel: BASE.AVG
      }],
      loadFactor: [{
        name: BASE.LOAD_FACTOR_CURVE_CURRENT_YEAR,
        pinLineLabel: BASE.CURRENT,
        prolongWithExpect: true,
        squareIndicatorsType: BASE.CURRENT
      }, {
        name: BASE.LOAD_FACTOR_CURVE_LAST_YEAR,
        pinLineLabel: BASE.CURRENT_LY,
        dotted: true,
        customDash: BASE.LY_CUSTOM_DASH,
        squareIndicatorsType: BASE.CURRENT_LY,
        referenceType: BASE.REFERENCE_LY
      }, {
        name: BASE.LOAD_FACTOR_CURVE_SEASONAL_AVERAGE,
        pinLineLabel: BASE.CURRENT_SEASONAL_AVERAGE,
        dotted: true,
        customDash: BASE.LY_CUSTOM_DASH,
        squareIndicatorsType: BASE.CURRENT_SEASONAL_AVERAGE,
        referenceType: BASE.REFERENCE_SEASONAL_AVERAGE
      }, {
        name: BASE.LOAD_FACTOR_CURVE_URD_MIN,
        pinLineLabel: BASE.MIN
      }, {
        name: BASE.LOAD_FACTOR_CURVE_URD_MAX,
        pinLineLabel: BASE.MAX
      }, {
        name: BASE.LOAD_FACTOR_CURVE_URD_AVG,
        pinLineLabel: BASE.AVG
      }]
    },
    DA_AVAILABLE_CURVES: {
      booking: [{
        name: BASE.BOOKING_CURVE_CURRENT_YEAR,
        pinLineLabel: BASE.CURRENT,
        prolongWithExpect: true,
        squareIndicatorsType: BASE.CURRENT
      }, {
        name: BASE.BOOKING_CURVE_REFERENCE,
        pinLineLabel: BASE.SEASON_AVERAGE,
        prolongWithExpect: true,
        customDash: BASE.CAPACITY_CUSTOM_DASH
      }, {
        name: BASE.CAPACITY_CURVE_REFERENCE,
        pinLineLabel: BASE.DA_CAPACITY_SEASON_AVG,
        dotted: true,
        customDash: BASE.LY_CUSTOM_DASH,
        prolongWithExpect: true
      }, {
        name: BASE.CAPACITY_CURVE_CURRENT_YEAR,
        pinLineLabel: BASE.DA_CAPACITY,
        dotted: true,
        customDash: BASE.CAPACITY_CUSTOM_DASH
      }],
      loadFactor: [{
        name: BASE.LOAD_FACTOR_CURVE_CURRENT_YEAR,
        pinLineLabel: BASE.CURRENT,
        prolongWithExpect: true,
        squareIndicatorsType: BASE.CURRENT
      }, {
        name: BASE.LOAD_FACTOR_CURVE_REFERENCE,
        pinLineLabel: BASE.SEASON_AVERAGE,
        prolongWithExpect: true,
        customDash: BASE.CAPACITY_CUSTOM_DASH
      }]
    },
    EXPECTED_METRICS: [{
      metric: 'booking',
      name: BASE.BOOKINGS_EXPECTED,
      pinLineLabel: BASE.EXPECTED,
      screens: [dataRetrieverConstantsService.MARKET_SCREEN, dataRetrieverConstantsService.FLIGHT_SCREEN]
    }, {
      metric: 'revenue',
      name: BASE.REVENUE_EXPECTED,
      pinLineLabel: BASE.EXPECTED,
      screens: [dataRetrieverConstantsService.MARKET_SCREEN]
    }, {
      metric: 'revenue',
      name: BASE.REVENUE_EXPECTED_FLIGHT,
      pinLineLabel: BASE.EXPECTED,
      screens: [dataRetrieverConstantsService.FLIGHT_SCREEN]
    }, {
      metric: 'loadFactor',
      name: BASE.LOAD_FACTOR_EXPECTED_FLIGHT,
      pinLineLabel: BASE.EXPECTED,
      screens: [dataRetrieverConstantsService.FLIGHT_SCREEN]
    }]
  };
};
ProfileChartConstants.$inject = ['ChartElementsConstants', 'DataRetrieverConstantsService'];
module.exports = ProfileChartConstants;